/////////////// LIB. ///////////////
////////////////////////////////////

// ...

////////////// UTIL. ///////////////
////////////////////////////////////

import load_newsletterSignUpCaptcha from "../../utils/load_newsletterSignUpCaptcha";

////////////// ASSETS //////////////
////////////////////////////////////

import consoleStyles from "../../assets/consoleStyles/consoleStyles.js";

////////////////////////////////////
////////////////////////////////////

export default function eh_swup_contentReplaced() {
  ///////// New page scripts /////////
  ////////////////////////////////////

  // Load Newsletter Sign-Up Captcha if newsletter form is present
  console.log("%cChecking for Newsletter Sign-Up Captcha...", consoleStyles.default);
  if (document.querySelector(".group\\/NewsletterForm")) {
    load_newsletterSignUpCaptcha();
  }
}
